/**
 * Service Whitelist
 *
 * Manages the whitelist of services available to extensions. The host configures
 * it during initialization; the custom `@service` decorator validates against it.
 *
 * An empty whitelist means "no restriction"; a non-empty one allows only the
 * listed services.
 *
 * @example
 * import serviceWhitelist from '@peekops/peek-extensions-framework/runtime/service-whitelist';
 * serviceWhitelist.configure(['router', 'notifications']);
 */
class ServiceWhitelist {
  // Hard-private (runtime-enforced).
  #services: string[] = [];

  configure(allowedServices: string[]): void {
    this.#services = [...allowedServices];
  }

  /** A copy — mutating it does not affect the internal list. */
  list(): string[] {
    return [...this.#services];
  }

  /** Whether `name` may be injected (empty whitelist = no restriction). */
  isAllowed(name: string): boolean {
    return this.#services.length === 0 || this.#services.includes(name);
  }
}

export default new ServiceWhitelist();
